<template>
    <b-card title="" class="trigger-card p-2 mb-2" no-body>
        <b-card-body class="p-2">
            <b-row class="flex-md-row flex-column">
                <b-col class="mb-2 mb-md-0">
                    <span class="d-block mb-2"
                        >Apply for each property in reservation</span
                    >
                    <form-switch
                        class="active-switch"
                        color="#0d47a1"
                        labels=""
                        :value="applyForEachProperty"
                        @input="onChangeForEachProperty"
                        :sync="true"
                    />
                </b-col>
                <b-col class="mb-2 mb-md-0">
                    <span class="d-block mb-2"
                        >Apply to last minute reservations</span
                    >
                    <form-switch
                        class="active-switch"
                        color="#0d47a1"
                        labels=""
                        :value="applyToLastMinuteReservations"
                        @input="onChangeLastMinute"
                        :sync="true"
                    />
                </b-col>
                <b-col class="mb-2 mb-md-0">
                    <span class="d-block mb-2"
                        >Apply only once per reservation
                    </span>
                    <form-switch
                        class="active-switch"
                        color="#0d47a1"
                        labels=""
                        :value="applyOncePerReservation"
                        @input="onChangeOncePerRes"
                        :sync="true"
                    />
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import FormSwitch from '../../../generic/form-switch/form-switch.vue';
import { mapGetters } from 'vuex';
export default {
    components: {
        FormSwitch,
    },
    computed: {
        ...mapGetters('trigger', [
            'applyForEachProperty',
            'applyOncePerReservation',
            'applyToLastMinuteReservations',
        ]),
    },
    methods: {
        onChangeForEachProperty(value) {
            this.$store.commit('trigger/setForEachProperty', value);
            this.$store.commit('trigger/setEditing', true);
        },
        onChangeOncePerRes(value) {
            this.$store.commit('trigger/setOncePerRes', value);
            this.$store.commit('trigger/setEditing', true);
        },
        onChangeLastMinute(value) {
            this.$store.commit('trigger/setLastMinute', value);
            this.$store.commit('trigger/setEditing', true);
        },
    },
};
</script>

<style>
</style>